module.exports = __webpack_public_path__ + "static/estudiar-ingles-al-mar-a945703b4a67623eb699b10da80642db.png";